import * as React from 'react';
import { useState } from 'react';
import { Button } from 'reactstrap';
import moment from "moment";

import { Order } from '../../models/Order';
import { formatMoney } from "../../components/shared/Utils";

function SearchOrderCard(props: {
    reorderInProgress: boolean,
    order: Order,
    reorder: (order: Order) => void
}) {

    const { order, reorder, reorderInProgress } = props;

    const [isOpen, setIsOpen] = useState(false);

    const toggle = () => setIsOpen(!isOpen);

    const cannotReorder = (): boolean => {
        if (reorderInProgress) {
            return true;
        }

        if (!order) {
            return true;
        }

        if (!order.Items || order.Items.length === 0) {
            return true;
        }

        const hasAvailableItem = order.Items.some(item => item.IsAvailable);

        return !hasAvailableItem;
    }

    return <div className="mb-3 order-card">
        <div className="card-top d-flex py-3">
            <div className="card-top-section property-value">
                <span className="label">Order #:</span>
                <span className="value">{order.Number}</span>
            </div>
            <div className="card-top-section property-value">
                <span className="label">Date:</span>
                <span className="value">{moment(order.CreatedDate).locale("en-us").format("MMMM Do, YYYY")}</span>
            </div>
            <div className="card-top-section property-value">
                <span className="label">Cart Name:</span>
                <span className="value">{order.CartName}</span>
            </div>
            <div className="card-top-section section-angle-toggle d-flex align-items-center">
                <Button
                    color="primary"
                    outline
                    className="rounded-0 btn btn-reorder"
                    onClick={() => { reorder(order); }}
                    disabled={cannotReorder()}
                >
                    Reorder
                </Button>
                {false && <a title={"toggle " + order.Number} href="#" onClick={(e) => {
                    e.preventDefault();
                    toggle();
                }}><i className={"fa " + (isOpen ? "fa-angle-up" : "fa-angle-down")}></i></a>}
            </div>
        </div>
        <div className="cart-view table-responsive" key={`${order.Id}`}>
            <table className="table">
                <thead>
                    <tr>
                        <th>MFR PN</th>
                        <th>Description</th>
                        <th>QTY</th>
                        <th>Cost</th>
                        <th>Total</th>
                    </tr>
                </thead>
                <tbody>
                    {(order.Items || []).map(x =>
                        <tr key={`${x.Id}`} className={x.IsAvailable ? "" : "not-available"}>
                            <td>
                                <div className="lead text-nowrap product-number-cell">{x.ProductNumber}</div>
                            </td>
                            <td>
                                <div className="lead text-nowrap">{x.ProductName}</div>
                            </td>
                            <td>
                                <div className="lead cart-quantity">
                                    {x.Quantity}
                                </div>
                            </td>
                            <td>
                                <div className="lead text-nowrap">
                                    {x.Price > 0 ? formatMoney(x.Price) : "$--.--"}
                                </div>
                            </td>
                            <td>
                                <div className="lead text-nowrap">
                                    {x.Price > 0 ? formatMoney(x.Price * x.Quantity) : "$--.--"}
                                </div>
                            </td>
                        </tr>)}
                </tbody>
            </table>
        </div>
    </div>
}

export default SearchOrderCard;